import React, {useState} from 'react';

type Props = {
    onChange: (pageNames: PageName[]) => void,
    pageNames?: PageName[]
}

function PageCheckboxes({onChange, pageNames}: Props) {

    const [selectedPageNames] = useState<Set<PageName>>(new Set(pageNames));
    const allPageNames: PageName[] = ["HOME", "BOOKS", "EVENTS", "PEOPLE", "ROOM", "DINGE"];

    const onCheck = (pageName: PageName) => {
        if (selectedPageNames.has(pageName)) {
            selectedPageNames.delete(pageName);
        } else {
            selectedPageNames.add(pageName);
        }
        onChange(Array.from(selectedPageNames));
    }

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 w-full text-sm font-medium text-gray-900 dark:text-white">
            {
                allPageNames.map((pageName, index) => (
                    <label key={index}
                           className="flex items-center gap-2 px-3 py-2 bg-white border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:hover:bg-gray-600">
                        <input type="checkbox" value=""
                               className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                               defaultChecked={selectedPageNames.has(pageName)}
                               onChange={() => onCheck(pageName)}
                        />
                        <span className="text-sm font-medium text-gray-900 dark:text-gray-300">
                            {pageName}
                        </span>
                    </label>
                ))
            }
        </div>
    );
}

export default PageCheckboxes;
